module.exports = __webpack_public_path__ + "static/media/bottle-dropper.d1a64980.png";